import { render, staticRenderFns } from "./Cobros.vue?vue&type=template&id=cb2058ca&"
import script from "./Cobros.vue?vue&type=script&lang=js&"
export * from "./Cobros.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports